import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "./Home";
import ConsultsForClinicians from "./ConsultsForClinicians";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route
          path="/consults-for-clinicians"
          element={<ConsultsForClinicians />}
        />
      </Routes>
    </Router>
  );
}

export default App;
